const REGION_ID = "qualify-quiz";
const TOTAL_STEPS = 7;

export { REGION_ID, TOTAL_STEPS };
